import Vue from 'vue'
import Vuex from 'vuex'
import user from '../modules/users'
import coins from '../modules/gamification'
import module from '../modules/modules'
import task from '../modules/tasks'
import checklist from '../modules/checklist'
import plan from '../modules/plan'
import general from '../modules/general'
import timer from '../modules/timer'
import share from '../modules/share'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user,
    coins,
    module,
    task,
    checklist,
    plan,
    general,
    timer,
    share
  }
})
